import { Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useEffect } from 'react';
import { StyledFormSection } from './_elements';
import RecurrenceRuleSection from './RecurrenceRuleSection';

interface FormValues {
  start: string;
  end: string;
}

export default function DateSection() {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();
  const start = watch('start');

  useEffect(() => {
    if (start) {
      const newEndDate = moment.utc(start).add(30, 'minutes').toISOString();
      setValue('end', newEndDate);
    }
  }, [start, setValue]);

  return (
    <StyledFormSection>
      <Typography variant='h6' sx={{ mt: 2 }}>
        Date & Time
      </Typography>
      <Stack direction='row' spacing={2} sx={{ my: 2 }}>
        <Controller
          name='start'
          control={control}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                {...field}
                value={
                  field.value &&
                  moment(field.value, moment.ISO_8601, true).isValid()
                    ? moment.utc(field.value)
                    : null
                }
                onChange={(date) => field.onChange(date?.toISOString() || '')}
                label='Start Date'
                slotProps={{
                  textField: {
                    error: !!errors.start,
                    helperText: errors.start?.message,
                  },
                }}
                sx={{
                  flex: 1,
                }}
              />
            </LocalizationProvider>
          )}
        />
        <Controller
          name='end'
          control={control}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                {...field}
                value={
                  field.value &&
                  moment(field.value, moment.ISO_8601, true).isValid()
                    ? moment.utc(field.value)
                    : null
                }
                onChange={(date) => field.onChange(date?.toISOString() || '')}
                label='End Date'
                slotProps={{
                  textField: {
                    error: !!errors.end,
                    helperText: errors.end?.message,
                  },
                }}
                sx={{
                  flex: 1,
                }}
              />
            </LocalizationProvider>
          )}
        />
      </Stack>
      <RecurrenceRuleSection />
    </StyledFormSection>
  );
}
